import { BUILT_IN_LAYOUT_DEFAULT_UTILITY_PROPS } from '@smoothie-framework/ui-styles/styling/contract';
import { buildFlexContainerNode, } from '../../authoring/flex-layout';
export function StackRow(props) {
    const { id, as, asChild, gap = defaultStackRowProps.gap, align = defaultStackRowProps.align, justify = defaultStackRowProps.justify, wrap = defaultStackRowProps.wrap, style, role, ariaLabel, ariaLabelledBy, 'aria-labelledby': ariaLabelledByAttribute, ariaDescribedBy, className, children, 'data-ui': dataUi, ...utilityPropsInput } = props;
    return buildFlexContainerNode({
        componentType: 'StackRow',
        baseClass: 'smth-stack-row',
        defaultDataUi: 'StackRow',
        defaultGap: defaultStackRowProps.gap,
        defaultAlign: defaultStackRowProps.align,
        defaultJustify: defaultStackRowProps.justify,
        defaultWrap: defaultStackRowProps.wrap,
        defaultDirection: 'row',
        gap,
        align,
        justify,
        wrap,
        emitDirectionProp: false,
        id,
        as,
        asChild,
        style,
        role,
        ariaLabel,
        ariaLabelledBy: ariaLabelledBy !== undefined ? ariaLabelledBy : ariaLabelledByAttribute,
        ariaDescribedBy,
        className,
        children,
        dataUi,
        utilityPropsInput,
    });
}
const stackRowDefaultUtilityProps = BUILT_IN_LAYOUT_DEFAULT_UTILITY_PROPS.StackRow;
export const defaultStackRowProps = Object.freeze({
    gap: stackRowDefaultUtilityProps.gap,
    align: stackRowDefaultUtilityProps.align,
    justify: stackRowDefaultUtilityProps.justify,
    wrap: stackRowDefaultUtilityProps.wrap,
});
//# sourceMappingURL=StackRow.js.map